<template>
  <v-col class="pb-0">
    <v-autocomplete
      :items="reasons"
      :loading="$apollo.loading"
      item-value="uuid"
      item-text="name"
      outlined
      label="Orsak"
      v-model="reason_uuid"
      :disabled="disabled"
      persistent-hint
    />
  </v-col>
</template>

<script>
import { sync } from 'vuex-pathify'
import gql from 'graphql-tag'
import { required } from '@/common/validationRules'

export default {
  name: 'EventReasonField',

  props: {
    disabled: Boolean
  },

  data: () => ({
    required
  }),

  computed: {
    reason_uuid: sync('event/model@reason_uuid')
  },

  apollo: {
    reasons: {
      query: gql`
        query reasons {
          reasons {
            uuid
            name
          }
        }
      `
    }
  }
}
</script>
